import React, { useState, useContext } from "react";
import loginpng from "../img/loginpng.jpg";
import logo from "../img/logo.png";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import { instance2 } from "../utils/axiosInstance";
import translations from "../login/translations"; // Adjust the path as needed
import { LanguageContext } from "../login/LanguageContext";
import ForgetPassword from "./forgetpassword";
import { ReactComponent as EyeOn } from "../img/eyeon.svg";
import { ReactComponent as EyeOff } from "../img/eyeoff.svg";
import { usePwa } from "../utils/usePwa";
import { Button } from "../shadcn/button";
import { CirclePlus } from "lucide-react";

export default function Login() {
  const [isFormVisible, setFormVisible] = useState(true); // State to toggle form visibility
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);
  const { canInstall, installPrompt } = usePwa();

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    ...formik
  } = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: yup.object({
      username: yup.string().required(translations[language].textEmpty),
      password: yup.string().required(translations[language].passwordEmpty),
    }),
    onSubmit: async (result) => {
      try {
        const checkstatus1 = await instance2.post("checkemail", result);
        console.log("result", result);
        console.log("responselogin", result, checkstatus1);
        if (checkstatus1.status === 1) {
          const response = await instance2.post("auth/login", result);
          const admincheck = await instance2.get(`admins/${result.username}`);

          console.log("response /admins/username", admincheck);
          console.log(
            "response2 /admins/username",
            admincheck,
            `admins/${result.username}`,
          );
          localStorage.setItem("userAuthentication", result.username);
          localStorage.setItem(
            "userId",
            admincheck.data[0].id ? admincheck.data[0].id : "",
          );
          localStorage.setItem("ACCESS", response.access_token);
          localStorage.setItem(
            "locationId",
            admincheck.data[0].location_id
              ? admincheck.data[0].location_id
              : "",
          );
          localStorage.setItem(
            "locationname",
            admincheck.data[0].location_name
              ? admincheck.data[0].location_name
              : "",
          );
          localStorage.setItem(
            "kitchenId",
            admincheck.data[0].kitchen_id ? admincheck.data[0].kitchen_id : "",
          );
          localStorage.setItem(
            "kitchenname",
            admincheck.data[0].kitchen_name
              ? admincheck.data[0].kitchen_name
              : "",
          );
          localStorage.setItem(
            "rolename",
            admincheck.data[0].role_name ? admincheck.data[0].role_name : "",
          );
          localStorage.setItem(
            "rolecode",
            admincheck.data[0].role_code ? admincheck.data[0].role_code : "",
          );
          localStorage.setItem(
            "roleId",
            admincheck.data[0].role_code ? admincheck.data[0].role_id : "",
          );
          localStorage.setItem("name", response.name);


          // console.log("response");
          // console.log("token",response.access_token);
          // console.log(result.username);
          // console.log(admincheck.data[0]);
          // console.log(admincheck.data[0].location_name);
          navigate("/");
        } else if (checkstatus1.status === 2) {
          navigate("/sendmail", { state: { email: result.email } });
        } else if (checkstatus1.status === 3) {
          formik.setErrors({
            username: translations[language].lockedAccount,
          });
        } else {
          formik.setErrors({
            username: translations[language].wrongUsername,
            password: translations[language].wrongPassword,
          });
        }
      } catch (error) {
        formik.setErrors({
          username: translations[language].wrongUsername,
          password: translations[language].wrongPassword,
        });
      }
    },
  });

  const [showPassword, setShowPassword] = useState(false); // State to toggle visibility

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="flex w-full h-screen flex-col sm:flex-col md:flex-row lg:flex-row">
      {/* Left Side */}
      <div
        className="flex items-center justify-center flex-1 flex-col"
        style={{
          backgroundImage: `url(${loginpng})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <img
          className="flex items-center justify-center z-10"
          src={logo}
          alt="/"
        />
        <div
          className="text-white text-center text-4xl sm:text-4xl md:text-6xl lg:text-6xl leading-[60px] font-medium"
          style={{
            textShadow: "0px 3px 6px rgba(0, 0, 0, 0.5)",
          }}
        >
          Efisiensi di Setiap
          <br />
          Proses.
        </div>
      </div>

      {/* Right Side */}
      <div className="flex flex-col justify-center items-center h-full flex-1 bg-[#EEEFF1]">
        <div className="text-black text-center text-4xl sm:text-4xl md:text-6xl leading-[60px] font-medium">
          Dapur
          <br />
          Merdeka
        </div>
        {/* <div className="text-black text-center text-3xl sm:text-2xl md:text-2xl leading-[60px] font-medium py-10">
          Silahkan Isi Data Anda
        </div> */}
        {/* <div className="text-black text-lg text-center font-thin">V 1.0</div> */}
        {isFormVisible ? (
          <div>
            {/* <div className="text-black text-lg text-center font-thin">
      Daftarkan Diri Anda Sekarang
    </div>
    <div className="text-black text-lg text-center font-thin">
      Belum punya akun?{' '}
      <span
        className="text-red-500 cursor-pointer"
        onClick={handleMasukClick} // Toggles the state
      >
        Daftar
      </span>
    </div> */}
          </div>
        ) : (
          <div>
            {/* <div className="text-black text-lg text-center font-thin">
    Daftarkan Diri Anda Sekarang
    </div>
    <div className="text-black text-lg text-center font-thin">
      Sudah punya akun?{' '}
      <span
        className="text-red-500 cursor-pointer"
        onClick={handleMasukClick} // Toggles the state back
      >
        Masuk
      </span>
    </div> */}
          </div>
        )}
        {/* Conditional Rendering for Below Content */}
        {isFormVisible ? (
          // Login Form
          <form className="w-full mx-auto mt-4 px-20" noValidate>
            <div className="flex flex-col">
              <label>Masuk</label>
              <input
                className="relative bg-white p-2 rounded-[25px] border-none py-4"
                type="text"
                name="username"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.username}
                placeholder="Nama Pengguna"
              />
              <small className="text-red-500">
                {touched.username && errors.username}
              </small>
            </div>
            <div className="mt-8">
              <div className="flex flex-col">
                <label>Kata Sandi</label>
                <div className="relative">
                  {/* Password Input */}
                  <input
                    className="relative bg-white p-2 rounded-[25px] border-none py-4 pr-12 w-full"
                    type={showPassword ? "text" : "password"} // Toggle type
                    name="password"
                    onChange={handleChange}
                    value={values.password}
                    placeholder="Kata Sandi"
                  />
                  {/* Toggle Button */}
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2"
                  >
                    {showPassword ? (
                      <EyeOff className="w-6 h-6 text-gray-500" />
                    ) : (
                      <EyeOn className="w-6 h-6 text-gray-500" />
                    )}
                  </button>
                </div>
                {/* Error Message */}
                <small className="text-red-500">
                  {touched.password && errors.password}
                </small>
              </div>
            </div>
            <button
              className="w-full py-3 bg-merah-no my-4 hover:bg-merah-hover text-white border rounded-[20px]"
              onClick={handleSubmit}
              type="submit"
            >
              {translations[language].loginButton}
            </button>
            {canInstall && (
              <Button
                type="button"
                onClick={installPrompt}
                className="flex items-center gap-2 ml-auto w-full lg:w-auto"
              >
                <CirclePlus />
                <span>Install App</span>
              </Button>
            )}
          </form>
        ) : (
          // Signup Component when "Masuk" is clicked
          <ForgetPassword />
        )}
      </div>
    </div>
  );
}
